// Shared helpers for rendering notifications.
import { formatDistanceToNow } from "date-fns";
import Cookies from "js-cookie";

// Best-effort deep link for a notification, derived from its `data`/`project_id`.
// Returns a route path string, or null when there's nothing to open.
export const notificationLink = (n) => {
  if (!n) return null;
  const data = n.data || {};
  if (data.saved_search_id)
    return `/tender-search?saved=${data.saved_search_id}${data.organization_id ? `&org=${data.organization_id}` : ""}`;
  if (data.tender_matches)
    return `/tender-search/discover${data.organization_id ? `?org=${data.organization_id}` : ""}`;
  const folderId = data.folder_id || n.project_id;
  if (!folderId) return null;

  const orgId = Cookies.get("selected_org_id");
  // Both org-scoped and non-org project routes exist; prefer org-scoped when known.
  return orgId
    ? `/rfp-projects/project/${folderId}/org/${orgId}`
    : `/rfp-projects/project/${folderId}`;
};

// Initials for the actor avatar; falls back to a bell glyph for system events.
export const actorInitials = (name) => {
  const clean = (name || "").trim();
  if (!clean) return null; // -> caller renders a system/bell avatar
  const parts = clean.split(/\s+/);
  const first = parts[0]?.[0] || "";
  const second = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + second).toUpperCase();
};

// Safe relative time ("2 hours ago"). Never throws on bad input.
export const relativeTime = (iso) => {
  if (!iso) return "";
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return "";
  }
};
